import { render, staticRenderFns } from "./AiCallHistoryList.vue?vue&type=template&id=2c5c712c&scoped=true"
import script from "./AiCallHistoryList.vue?vue&type=script&lang=js"
export * from "./AiCallHistoryList.vue?vue&type=script&lang=js"
import style0 from "./AiCallHistoryList.vue?vue&type=style&index=0&id=2c5c712c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5c712c",
  null
  
)

export default component.exports